import { forwardRef } from 'react'
import { IconProps } from '../Types'

export const Collapse = forwardRef<SVGSVGElement, IconProps>(
  ({ color = 'currentColor', size = 12 }, forwardedRef) => {
    return (
      <svg
        width={size}
        height={size}
        viewBox={`0 0 ${size} ${size}`}
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        ref={forwardedRef}
      >
        <svg width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M7.25031 1.87501C7.25031 1.59887 7.02646 1.37501 6.75032 1.375C6.47418 1.37499 6.25031 1.59885 6.25031 1.87499L6.25023 5.25006C6.25023 5.38267 6.30291 5.50985 6.39668 5.60362C6.49045 5.69739 6.61762 5.75007 6.75023 5.75007L10.1253 5.75007C10.4014 5.75007 10.6253 5.52621 10.6253 5.25007C10.6253 4.97393 10.4014 4.75007 10.1253 4.75007L7.95734 4.75007L10.4789 2.22856C10.6741 2.0333 10.6741 1.71671 10.4789 1.52145C10.2836 1.32619 9.96701 1.32619 9.77175 1.52145L7.25026 4.04294L7.25031 1.87501ZM4.7501 10.1251C4.7501 10.4012 4.97396 10.6251 5.2501 10.6251C5.52624 10.6251 5.7501 10.4012 5.7501 10.1251L5.75014 6.74996C5.75014 6.61735 5.69746 6.49018 5.6037 6.39641C5.50993 6.30264 5.38275 6.24996 5.25014 6.24996H1.875C1.59886 6.24996 1.375 6.47382 1.375 6.74996C1.375 7.0261 1.59886 7.24996 1.875 7.24996H4.04303L1.52145 9.77155C1.32618 9.96681 1.32618 10.2834 1.52145 10.4787C1.71671 10.6739 2.03329 10.6739 2.22855 10.4787L4.75013 7.95708L4.7501 10.1251Z"
            fill={color}
          />
        </svg>
      </svg>
    )
  },
)

export default Collapse
